import styled from "styled-components";
import {LobbyHeaderDefaultButtonsBox} from "./lobby-header-button.default.box";

export const LobbyHeader777ButtonsBox = styled(LobbyHeaderDefaultButtonsBox)`
    border: 2px solid ${props => props.theme.colors.boxBorderContrast};
    border-radius: 5px;
`;
